import * as React from "react";
import { toast } from "react-toastify";
import { Modal, ModalBody } from "reactstrap";
import {
  clientAuditUploadFile,
  clientUploadSubmitCheckpointLocation,
  vendorFileUpload,
  vendorUploadSubmitCheckpointLocation,
} from "@services/auth.service";
import { getValue } from "@utils/lodash";
import "./upload-modal.scss";

interface IUploadModalProps {
  isOpen: boolean;
  handleModal: () => void;
  getData: () => void;
  vendorInfo: object;
}

const UploadModal: React.FunctionComponent<IUploadModalProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [uploadedDocuments, setUploadedDocuments] = React.useState<any>([]);

  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      let payload = {
        vendor_checkpoint: [
          {
            id: getValue(props, `vendorInfo.id`, ""),
            document_ids: uploadedDocuments.map((item: object) =>
              getValue(item, `id`, "")
            ),
          },
        ],
        // domain_name: getValue(localStorage,`client`,''),
      };
      let resp = await clientUploadSubmitCheckpointLocation(payload);
      if (resp) {
        setSubmitLoading(false);
        props.handleModal();
        props.getData();
        toast.success("Uploaded successfully");
      } else {
        props.getData();
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, "") !== id
    );
    setUploadedDocuments(filtered);
  };

  const [uploadLoading, setUploadLoading] = React.useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    const files = Array.from(e.target.files);

    setUploadLoading(true);

    try {
      for (const item of files) {
        const formData = new FormData();
        formData.append("file", item as any);

        try {
          const resp = await clientAuditUploadFile(formData); // waits here

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
            setUploadedDocuments([...uploadedDocuments]);
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e.target.value = null;
      setUploadLoading(false);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAuditUploadFile(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  return (
    <div className="comments-popup">
      <Modal
        isOpen={getValue(props, `isOpen`, "")}
        toggle={getValue(props, `isOpen`, "")}
        centered
        size="lg"
      >
        <div className="comments-modal">
          <div className="comments-popup__header d-flex align-items-center justify-content-between mb-3">
            <h3 className="comments-popup__header-title">Attach File</h3>
            <div className="d-flex justify-content-end">
              <button
                className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                onClick={() => props.handleModal()}
              >
                Cancel
              </button>
              {submitLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                  Please wait...
                </button>
              ) : (
                <button
                  className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                  onClick={handleSubmit}
                  disabled={
                    !getValue(props, `permissions`, []).includes("update") ||
                    getValue(uploadedDocuments, `length`, 0) === 0
                  }
                >
                  {"Submit"}
                </button>
              )}
            </div>
          </div>
          <ModalBody>
            <div>
              <div>
                <div>
                  <h6 className="comments-popup__vendor-name">Task ID</h6>
                  <p className="comments-popup__vendor-text">
                    {getValue(props, `vendorInfo.task_id`, "")}
                  </p>
                </div>
                <div className="comments-popup__vendor-details">
                  <h6 className="comments-popup__vendor-name">Legislation</h6>
                  <p className="comments-popup__vendor-text">
                    {getValue(
                      props,
                      `vendorInfo.checkpoint.legislation.legislation_name`,
                      ""
                    )}
                  </p>
                </div>
              </div>
              <div
                onDrop={handleDrop}
                onDragOver={
                  !uploadLoading
                    ? getValue(props, `permissions`, []).includes("update")
                      ? handleDragOver
                      : disableUpload
                    : disableUpload
                }
                className="mt-3"
              >
                <p className="mb-2">Files Upload{" 	"}</p>
                <label className="custom-file-upload-popup">
                  {uploadLoading ? (
                    <p>Please wait...</p>
                  ) : (
                    <>
                      <p className="custom-inputfile__attach">
                        Drag & Drop Files here
                      </p>
                      <p className="custom-inputfile__attach">OR</p>
                      <a href="#0">
                        <p className="custom-inputfile__attach">Browse Files</p>
                      </a>
                    </>
                  )}
                  <input
                    type="file"
                    onChange={
                      !uploadLoading
                        ? getValue(props, `permissions`, []).includes("update")
                          ? handleUploadDocuments
                          : disableUpload
                        : disableUpload
                    }
                    multiple
                    className="d-none"
                  />
                </label>
              </div>
              {/* <h3 className="attach-files-wrapper__select">
								Select from uploaded files
							</h3> */}
              {getValue(uploadedDocuments, `length`, 0) > 0 ? (
                uploadedDocuments.map((item: object, key: number) => {
                  return (
                    <div
                      key={key}
                      className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                    >
                      <p>
                        {getValue(item, `name`, "")}
                        {getValue(item, `extension`, "")}
                      </p>
                      <div>
                        <img
                          src="/images/close-black.svg"
                          className="img-fluid cursor-pointer"
                          onClick={() =>
                            handleRemoveUploadedFiles(getValue(item, `id`, ""))
                          }
                        />
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-center mt-2"></p>
              )}
              <div></div>
            </div>
          </ModalBody>
        </div>
        <div className="footer-wrapper d-flex justify-content-between mt-4">
          <img src="/images/building-illustration.svg" className="img-fluid" />
        </div>
      </Modal>
    </div>
  );
};

export default UploadModal;
